




































































import _ from "lodash";
import { UIModel } from "../../UIModel";
import { Prop, Component, Vue } from "vue-property-decorator";
import { BIM360IssueStatus, BIM360Issue } from '@/model/BIM360Issue';
import { FrontendBIM360Issue } from '@/model/frontend/FrontendBIM360Issue';
import { BulkIssueTemplate } from '../../model/frontend/BulkIssueTemplate';
import { FrontendBIM360IssueComment } from '../../model/frontend/FrontendBIM360IssueComment';

@Component({
	components: {},
})
export default class Issues extends Vue {
	// Props
	@Prop({ required: true }) public model!: UIModel;
	@Prop({ required: true }) public isNew!: boolean;

	// Data
	public show = false;
	public fieldNames = {
		type: "Type",
		issueSubtypeId: "Sub Type",
		rootCause: "Root Cause",
		dueDate: "Due Date",
		assignedTo: "Assigned To"
	}

	public isProcessing = false;

	// Getters
	get comments(): string {
		let string = '';
		let comment_copy = JSON.parse(JSON.stringify(this.model.issueComment));
		let inside_obj = false;
		for (let i = 0; i < comment_copy.length;) {
			if (comment_copy[i] == '@') {
				let user_data = comment_copy.substr(i + 1, comment_copy.substr(i + 1, comment_copy.length - 1).indexOf("}") + 1);
                if (user_data) { string += JSON.parse(user_data).name; }
			} else if (comment_copy[i] == '{') {
				inside_obj = true;
			} else if (comment_copy[i] == '}') {
				inside_obj = false;
			} else {
				if (!inside_obj) {
					string += comment_copy[i];
				}
			}
			i++;
		}
		return string;
	}

	get newIssueStatusesAvailable(): any {
		return [BIM360IssueStatus.Draft, BIM360IssueStatus.Open];
	}

	get isMobile(): boolean {
		if (window) {
			return window.innerWidth < 768;
		} else {
			return false;
		}
	}

	get templatedIssues(): any[] {
		if (this.model.newIssueArray.length > 10) {
			return this.model.newIssueArray.slice(0, 10);
		} else {
			return this.model.newIssueArray;
		}
	}

	// Methods
	public open()
	{
		this.show = true;
	}

	public snackbar() {
		let actionText = "OK";
		let type = 'is-danger';
		let message = `Failed to create ${this.model.newIssueFailures} new issues.`;
		if(!this.isNew)message = `Failed to edit ${this.model.newIssueFailures} issues.`;
		if (this.model.newIssueSuccesses == this.model.newIssueCount) {
			actionText = "Cool!";
			type = 'is-success';
			message = `Successfully created ${this.model.newIssueSuccesses}/${this.model.newIssueCount} new issues.`;
			if(!this.isNew)message = `Successfully edited ${this.model.newIssueSuccesses} issues.`;
		} else if (this.model.newIssueSuccesses > 0) {
			actionText = "Nice!";
			type = 'is-success';
			message = `Successfully created ${this.model.newIssueSuccesses}/${this.model.newIssueCount} new issues.`;
			if(!this.isNew)message = `Successfully edited ${this.model.newIssueSuccesses} issues.`;
		}

		this.$buefy.snackbar.open({
			indefinite: true,
			message: message,
			actionText: actionText,
			type: type,
			position: "is-bottom-right",
			queue: false,
			onAction: () => {
				if (this.model.selectedProject) {
					this.model.getIssues(this.model.selectedProject.hubId, this.model.selectedProject.id, this.model.selectedProject.issueContainerId);
				}
				this.model.issueCheckedRows = [];
				this.model.newIssueArray = [];
				this.model.newIssueCount = 0;
				this.model.newIssueSuccesses = 0;
				this.model.newIssueFailures = 0;
			}
		});
	}
			
	public getFriendlyName(status: BIM360IssueStatus) {
		return BIM360Issue.friendlyNameForStatus(status);
	}

	public getFriendlyFieldName(field_name: string) {
		return !this.fieldNames[field_name] ? field_name : this.fieldNames[field_name];
	}
	
	public back(): void {
		this.show = false;
		this.clearCache();
		this.$emit("closed", false);
	}

	public clearCache(): void {
		this.model.newIssueTemplate = new BulkIssueTemplate(new FrontendBIM360Issue(), this.model);
		this.model.newIssueArray = [];
        this.model.issueComment = "";
	}

	public getAssignedToType(assignTo: string): string
	{
		if(this.model.projectUsers)
		{
			const users = Object.values(this.model.projectUsers);	
			const theUser = users.find(u => u.forgeID == assignTo);
			console.log("theUser", theUser);
			if(theUser) return 'user';
		}
		if(this.model.projectRoles && this.model.projectRoles[assignTo])
		{
			return 'role';
		}

		if(this.model.companies && this.model.companies[assignTo])
		{
			return 'company';
		}
		return 'user';
	}

	public async create(): Promise<void> {
		// Hide the modal
		this.isProcessing = true;
		this.model.newIssueSuccesses = 0;
		this.model.newIssueFailures = 0;

		for (const issue of this.model.newIssueArray) {
			let updateObj = issue.generateUpdatedPropertiesObject();
			this.model.issueIDsForComment.push(updateObj.forgeId);
		}

		let closed_issues: any[] = [];
		let other_issues: any[] = [];
		try {
			for (const issue of this.model.newIssueArray) {
				//add asignedToType
				issue.assignedToType = this.getAssignedToType(issue.assignedTo);
			}
			for (const issue of this.model.newIssueArray) {
				const target_issue = this.model.projectIssues.data.find((match_issue: FrontendBIM360Issue) => {
					return match_issue.id == issue.id
				});
				if (!target_issue) {
					continue
				} else {
					if (target_issue.status == "closed") {
						closed_issues.push(issue);
					} else {
						other_issues.push(issue);
					}
				}
			}
			// console.log(`${closed_issues.length} are already closed!`);
			// console.log(`${other_issues.length} are not already closed!`);

			if (other_issues.length > 0) {
				// Send comments if they are provided
				if (this.model.issueComment !== "") {
					await Promise.all(other_issues.map(async (issue) => {
						const body: FrontendBIM360IssueComment = {
							issue_id: issue.forgeId,
							body: this.model.issueComment
						};
						if (this.model.selectedProject) {
							this.model.addIssueComment(body, this.model.selectedProject);
						}
					}));
				}
			}

			// Send the new issues
			await this.model.bulkCreateOrUpdateIssues(this.isNew);
			this.model.newIssueTemplate = new BulkIssueTemplate(new FrontendBIM360Issue(), this.model);

			if (closed_issues.length > 0) {
				// Send comments if they are provided
				if (this.model.issueComment !== "") {
					for (let issue of closed_issues) {
						const body: FrontendBIM360IssueComment = {
							issue_id: issue.forgeId,
							body: this.model.issueComment
						};
						if (this.model.selectedProject) {
							this.model.addIssueComment(body, this.model.selectedProject);
						}
					}
					
				}
			}

		} catch(e) {
			console.log(e);
		} finally {
			this.model.issueComment = "";
			this.model.issueIDsForComment = [];
			this.clearCache();
			// Show the summary in the snackbar
			this.snackbar();
			this.isProcessing = false;
			this.show = false;
			this.$emit("closed", true);		
		}		
	}
}
